import {Trans} from 'react-i18next'
import makeStyles from '@material-ui/core/styles/makeStyles'
import messages from '../../../assets/messages'
import {Account} from '../../../graphql/types'
import {getTauroFactorisationFromAccount} from '../../../common/utils/accounts'

const TAURO_ORANGE = '#F57C00'

const useStyles = makeStyles(() => ({
  pill: {
    // Same layout as the PAMM money manager pill: a line of its own, shrink-to-fit.
    display: 'block',
    width: 'fit-content',
    marginTop: 2,
    padding: '1px 8px',
    borderRadius: 10,
    fontSize: 12,
    lineHeight: 1.5,
    fontWeight: 600,
    color: '#FFFFFF',
    backgroundColor: TAURO_ORANGE,
  },
}))

/**
 * Orange `{x}x` pill on a Tauro factorised account in the account pickers, so the client sees
 * which account takes the one-time withdrawal flow. Renders nothing for other accounts (PT-6615).
 */
export const TauroMultiplierPill = ({account}: {account: Account}) => {
  const classes = useStyles()
  const multiplier = getTauroFactorisationFromAccount(account)?.multiplier

  if (multiplier == null) return null

  return (
    <span className={classes.pill} data-testid="tauro-multiplier-pill">
      <Trans {...messages.tauroFactorisedBadge} values={{multiplier}} />
    </span>
  )
}
